import React, { Component } from 'react';
import Modal from './_Modal';

class SaveForkModal extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.open) {
      setTimeout(() => {
        nextProps.closeModal(nextProps.method)
      }, 1000);
    }
  }
  render() {
    return (
      <Modal open={this.props.open}
        close={() => this.props.closeModal(this.props.method)}>
        <h3>{this.props.method === "save" ? `✅  Envelope Saved` : `✅  Envelope Copied`}</h3>
      </Modal>
    )
  }
}

export default SaveForkModal;



// WEBPACK FOOTER //
// ./src/_SaveForkModal.js